import type { SplitTestVariant, SystemSplitTestKey } from 'autogen/swagger/all';
import useSplitTestValue from 'hooks/user/useSplitTestValue';

/**
 * A component that renders its children when the specified variant and systemSplitTestKey matches.
 * The negate prop reverses the match
 */
export default function WhenSplitTestVariant({
    children,
    variant,
    systemSplitTestKey,
    negate = false
}: {
    children: JSX.Element;
    variant: SplitTestVariant;
    systemSplitTestKey: SystemSplitTestKey;
    negate?: boolean;
}) {
    const splitTestValue = useSplitTestValue(systemSplitTestKey);

    if (negate) return variant === splitTestValue ? null : children;

    return variant === splitTestValue ? children : null;
}
